import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const RichTextElem = styled.div`
  > p {
    margin-bottom: 1rem;
  }

  a {
    cursor: pointer;
    color: ${fullConfig.theme.extend.colors.primary.default};
    transition-property: color;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
    &:hover {
      opacity: 0.8;
    }
    &:focus {
      opacity: 0.6;
      outline: none;
    }
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 1rem;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  ul,
  ol {
    margin-left: 2rem;
    margin-bottom: 1rem;
  }

  > p + ul,
  > p + ol {
    margin-top: -1rem;
  }

  .richtext-image {
    &.right {
      margin-left: auto;
    }
  }
`;

export default RichTextElem;
